/* import __COLOCATED_TEMPLATE__ from './filter-pill.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();